// extracted by mini-css-extract-plugin
export default {"header":"Products_header__Rl4vV","itemsList":"Products_itemsList__o006w"};